module.exports = __webpack_public_path__ + "img/hyu_gallery6.27271d1a.jpg";